import { render, staticRenderFns } from "./applyForm.vue?vue&type=template&id=70937fa1&scoped=true&"
import script from "./applyForm.vue?vue&type=script&lang=js&"
export * from "./applyForm.vue?vue&type=script&lang=js&"
import style0 from "./applyForm.vue?vue&type=style&index=0&id=70937fa1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70937fa1",
  null
  
)

export default component.exports